import classNames from "classnames";
import { useFilterManager, FilterManagerWrapper } from "@ugg/shared/components/FilterManager/FilterManager";
import { MediaQuery } from "@outplayed/responsive";
import { ReactComponent as FilterIcon } from "@ugg/shared/assets/svg/filters-icon.svg";
import WatchGameSwitcher from "./WatchGameSwitcher";
import { FilterOption } from "@ugg/shared/interfaces/filter-manager.interface";

interface WatchGameFilterManagerProps {
  className?: string;
  currentGame: string;
  disableByQueueType?: boolean;
  disableTooltip?: boolean;
  isMobile?: boolean;
  isDefault: boolean;
  listOfGamesTest: any;
  onFilterChange: (filterType: string, filterOption: FilterOption | null) => void;
}

export const WatchGameFilterManager: React.FC<WatchGameFilterManagerProps> = ({
  className,
  currentGame,
  onFilterChange,
  listOfGamesTest,
}) => {
  return (
    <FilterManagerWrapper className={classNames("filter-manager_tier-list filter-manager pb-[30px]", className)}>
      <div className="filter-manager_label">
        <FilterIcon />
        <MediaQuery min="TABLET" max="DESKTOP_LARGE">
          <span>Filters</span>
        </MediaQuery>
      </div>
      <div className="flex-1 flex items-center flex-wrap gap-[12px]">
        <WatchGameSwitcher
          isDefault={false}
          currentGame={currentGame}
          onFilterChange={onFilterChange}
          options={listOfGamesTest}
          disableTooltip
          disableByQueueType
        ></WatchGameSwitcher>
      </div>
    </FilterManagerWrapper>
  );
};
